import { render, staticRenderFns } from "./create_activity_birthdayGift.vue?vue&type=template&id=74766a86&scoped=true"
import script from "./create_activity_birthdayGift.vue?vue&type=script&lang=js"
export * from "./create_activity_birthdayGift.vue?vue&type=script&lang=js"
import style0 from "./create_activity_birthdayGift.vue?vue&type=style&index=0&id=74766a86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74766a86",
  null
  
)

export default component.exports